import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FreightBillingsDetailValue } from "../../../core/models/invoice-preview/FreightBillingsDetailValue";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { exportExcel } from "../../../core/services/shared.service";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";

@UntilDestroy()
@Component({
  selector: "jni-invoice-preview-order-tracking-line",
  templateUrl: "./invoice-preview-order-tracking-line.component.html",
  styleUrls: ["./invoice-preview-order-tracking-line.component.scss"],
  imports: [TableModule, CommonModule, HidedynamicsdatePipe],
})
export class InvoicePreviewOrderTrackingLineComponent
  implements OnInit, OnDestroy
{
  showSmallLoader = false;
  orderTrackingGridListing: FreightBillingsDetailValue[] = [];
  @Input() trackingNumber!: string;
  @Output() scrollHiddenStatus = new EventEmitter();

  constructor(
    private router: ActivatedRoute,
    private _loaderService: LoaderService,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService
  ) {
    this.router.params.subscribe(params => {
      this.trackingNumber = params["id"];
    });
  }

  ngOnInit(): void {
    this.getBillingDetailsLine();
  }

  getBillingDetailsLine() {
    this._loaderService.setLoaderState(true);
    if (this.trackingNumber) {
      const oDataFilter = `?$filter=TrackingNumber eq '${this.trackingNumber}'`;
      this._invoicePreviewSummaryService
        .getBillingDetailsLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.orderTrackingGridListing = res.data;
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  exportExcel() {
    exportExcel(this.orderTrackingGridListing, "Order Tracking Detail");
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }
}
